import type {ResourceType, Status} from "../types";

export enum ModalType {
    generateChecklist = "generateChecklist",
    generateDocuments = "generateDocuments",
    generateDocument = "generateDocument",
    sendToDokumentflyt = "sendToDokumentflyt",
    sendToDokumentflytStandalone = "sendToDokumentflytStandalone",
}

export type TopicMeta = {
    topicId: string;
    resourceId: string;
    resourceTypeId?: ResourceType;
    name: string;
};

export type CollectionMeta = {
    id: string;
};

export type ExportDocument = {
    id: string;
    name: string;
    selected: boolean;
    resourceTypeId?: ResourceType;
};

export type DeliveryFormat = "doc" | "zip" | "email";

export type GenerateButtonsInnerProps = {
    isChecklist?: boolean;
    isStandalone: boolean;
    isFetching: boolean;
    className?: string;
    topicMeta: TopicMeta;
    documents: ExportDocument[];
    collectionMeta?: CollectionMeta;
    labels?: string[];
    status?: (string | Status)[];
};
